// Inventory contracts (Milestone 2, PRD §5).
import { z } from 'zod';
import { pageQuery, uuid } from './common.js';
const qty = z.coerce.number().int().min(1).max(10_000_000);
const note = z.string().trim().max(500).nullable().optional();
const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'YYYY-MM-DD');
export const balanceQuery = pageQuery.extend({
    siteId: uuid.optional(),
    clientId: uuid.optional(),
    itemId: uuid.optional(),
    statusId: uuid.optional(),
    locationId: uuid.optional(),
    /** SKU, description, lot or location code. */
    q: z.string().trim().max(60).optional(),
    expiringWithinDays: z.coerce.number().int().min(0).max(3650).optional(),
    view: z.enum(['bucket', 'item']).default('bucket'),
});
export const moveRequest = z.object({
    balanceId: uuid,
    qty,
    toLocationId: uuid,
    toLpnId: uuid.nullable().optional(),
    reasonCodeId: uuid.nullable().optional(),
    note,
});
export const adjustRequest = z
    .object({
    /** Existing stock to adjust; or describe a new place for a found-stock increase. */
    balanceId: uuid.optional(),
    itemId: uuid.optional(),
    locationId: uuid.optional(),
    statusId: uuid.optional(),
    lot: z.string().trim().max(40).nullable().optional(),
    expiry: isoDate.nullable().optional(),
    serial: z.string().trim().max(60).nullable().optional(),
    delta: z.coerce
        .number()
        .int()
        .min(-10_000_000)
        .max(10_000_000)
        .refine((d) => d !== 0, 'Cannot adjust by zero'),
    reasonCodeId: uuid,
    note,
})
    .refine((v) => v.balanceId || (v.itemId && v.locationId && v.delta > 0), {
    message: 'Choose existing stock, or an item and location to add found stock',
});
export const statusChangeRequest = z.object({
    balanceId: uuid,
    qty,
    toStatusId: uuid,
    reasonCodeId: uuid,
    note,
});
export const holdRequest = z
    .object({
    siteId: uuid.nullable().optional(),
    clientId: uuid.nullable().optional(),
    itemId: uuid.nullable().optional(),
    lot: z.string().trim().max(40).nullable().optional(),
    locationId: uuid.nullable().optional(),
    statusId: uuid,
    reasonCodeId: uuid,
    note,
    isRecall: z.boolean().default(false),
})
    .refine((v) => v.clientId || v.itemId || v.lot || v.locationId, {
    message: 'Choose at least one of client, item, lot or location',
});
export const releaseHoldRequest = z.object({ toStatusId: uuid.optional(), note });
export const adjustmentDecision = z.object({ approve: z.boolean(), note });
export const countCreateRequest = z.object({
    siteId: uuid,
    locationIds: z.array(uuid).min(1).max(200),
    itemId: uuid.nullable().optional(),
    blind: z.boolean().default(true),
});
export const countGenerateRequest = z.object({
    siteId: uuid,
    zone: z.string().trim().max(20).optional(),
    max: z.coerce.number().int().min(1).max(500).default(25),
    blind: z.boolean().default(true),
});
export const countSubmitRequest = z.object({
    lines: z
        .array(z.object({
        itemId: uuid,
        lot: z.string().trim().max(40).nullable().optional(),
        expiry: isoDate.nullable().optional(),
        serial: z.string().trim().max(60).nullable().optional(),
        qty: z.coerce.number().int().min(0).max(10_000_000),
    }))
        .max(500),
});
export const countQuery = pageQuery.extend({
    siteId: uuid.optional(),
    state: z.enum(['open', 'recount', 'closed', 'cancelled']).optional(),
});
export const movementQuery = pageQuery.extend({
    siteId: uuid.optional(),
    itemId: uuid.optional(),
    lot: z.string().trim().max(40).optional(),
    locationId: uuid.optional(),
    type: z.string().max(20).optional(),
});
export const traceQuery = z.object({
    itemId: uuid.optional(),
    lot: z.string().trim().min(1).max(40),
});
//# sourceMappingURL=inventory.js.map